export default __webpack_public_path__ + "static/media/crepi.db71e889.jpg";